import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";
import React from "react";

// utils
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// === GENERATOR ===

export function generateTask() {
  const a1 = getRandomInt(1, 4);
  const k = getRandomInt(-3, 3);
  const m = getRandomInt(-5, 5);

  const a2 = a1 ** 2 + k * a1 + m;
  const a3 = a2 ** 2 + k * a2 + m;

  return {
    type: "RecursiveQuadraticTask",
    data: {
      a1,
      k,
      m,
      a2,
      a3
    }
  };
}

// === RENDER ===

export function renderTask({ data }) {
  const { a1, k, m } = data;

  const kTerm =
    k === 0 ? "" :
    k === 1 ? "+ a_n" :
    k === -1 ? "- a_n" :
    k > 0 ? `+ ${k}a_n` : `- ${Math.abs(k)}a_n`;

  const mTerm = m === 0 ? "" : m > 0 ? `+ ${m}` : `- ${Math.abs(m)}`;

  return (
    <div className="space-y-2">
      <p>Dany jest ciąg określony rekurencyjnie:</p>
      <BlockMath math={`\\begin{cases}a_1=${a1},\\\\a_{n+1}=a_n^2 ${kTerm} ${mTerm} & \\text{dla } n\\ge 1.\\end{cases}`} />
      <p>Oblicz wyraz <InlineMath math="a_3" /> tego ciągu.</p>
    </div>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      label="a_3"
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  if (given === null) return false;

  return given === data.a3;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`a_3 = ${data.a3}`} />;
}

export function renderExplanation({ data }) {
  const { a1, a2, a3, k, m } = data;

  const kTerm =
    k === 0 ? "" :
    k === 1 ? "+ a_n" :
    k === -1 ? "- a_n" :
    k > 0 ? `+ ${k}a_n` : `- ${Math.abs(k)}a_n`;

  const mTerm = m === 0 ? "" : m > 0 ? `+ ${m}` : `- ${Math.abs(m)}`;

  const kStep2 = k === 0 ? "" :
    k === 1 ? `+ ${a1}` :
    k === -1 ? `- ${a1}` :
    k > 0 ? `+ ${k * a1}` : `- ${Math.abs(k * a1)}`;

  const kStep3 = k === 0 ? "" :
    k === 1 ? `+ ${a2}` :
    k === -1 ? `- ${a2}` :
    k > 0 ? `+ ${k * a2}` : `- ${Math.abs(k * a2)}`;

  const mStep = m === 0 ? "" : m > 0 ? `+ ${m}` : `- ${Math.abs(m)}`;

  return (
    <div className="space-y-2" style={{ textAlign: "left" }}>
      <div>
        <strong>Krok 1:</strong> Wzór:
        <BlockMath math={`\\begin{cases}a_1=${a1},\\\\a_{n+1}=a_n^2 ${kTerm} ${mTerm} & \\text{dla } n\\ge 1.\\end{cases}`} />
      </div>

      <div>
        <strong>Krok 2:</strong> Obliczamy <InlineMath math="a_2" />:
        <BlockMath math={`a_2 = ${a1}^2 ${kStep2} ${mStep} = ${a2}`} />
      </div>

      <div>
        <strong>Krok 3:</strong> Obliczamy <InlineMath math="a_3" />:
        <BlockMath math={`a_3 = ${a2}^2 ${kStep3} ${mStep} = ${a3}`} />
      </div>

      <div>
        <strong>Odpowiedź:</strong>
        <BlockMath math={`a_3 = ${a3}`} />
      </div>
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`a_3 = ${userAnswer.raw}`} />;
}
